import { memo, Suspense } from 'react';
import type { SuspenseProps } from 'react';
import { clsx } from 'clsx';
import {
    FluidProgressIndicator,
    ProgressSpinner,
    SmallProgressIndicator,
} from '../ProgressIndicators';
import styles from './ComponentSuspense.module.css';

const Spinner = memo(
    ({ small, medium }: { small: boolean; medium: boolean }) => {
        if (small) {
            return <ProgressSpinner />;
        }
        if (medium) {
            return <SmallProgressIndicator />;
        }
        return <FluidProgressIndicator />;
    }
);

const ComponentSuspense = ({
    children,
    height = '100px',
    width = 'auto',
    small = false,
    medium = false,
    className,
}: Omit<SuspenseProps, 'fallback'> & {
    height?: string;
    width?: string;
    small?: boolean;
    medium?: boolean;
    className?: string;
}) => {
    return (
        <Suspense
            fallback={
                <div
                    className={clsx(styles.container, className)}
                    style={{
                        width,
                        height,
                    }}
                >
                    <Spinner small={small} medium={medium} />
                </div>
            }
        >
            {children}
        </Suspense>
    );
};

export default memo(ComponentSuspense);
